module.exports = __webpack_public_path__ + "img/value-blocks-slider-default.e619da80.png";